var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComponent2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.95722 2.12549H37.0435C37.7005 2.12549 38.3511 2.2549 38.9581 2.50633C39.5651 2.75776 40.1166 3.12629 40.5812 3.59087C41.0458 4.05545 41.4143 4.60699 41.6658 5.214C41.9172 5.821 42.0466 6.47159 42.0466 7.12861V37.1223C42.0466 37.7814 41.9164 38.4341 41.6634 39.0427C41.4104 39.6514 41.0396 40.204 40.5724 40.6689C40.1052 41.1338 39.5507 41.5018 38.9408 41.7518C38.3309 42.0017 37.6776 42.1287 37.0185 42.1254L6.93221 41.9853C5.60964 41.9787 4.34349 41.4487 3.41063 40.5111C2.47776 39.5736 1.95409 38.3048 1.9541 36.9822V7.12861C1.9541 5.8017 2.48121 4.52913 3.41948 3.59087C4.35775 2.6526 5.63031 2.12549 6.95722 2.12549V2.12549Z",
    stroke: "#473D8D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.9541 12.1318H42.0466",
    stroke: "#473D8D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9732 34.6457C33.3548 34.6457 34.4748 33.5257 34.4748 32.1441C34.4748 30.7626 33.3548 29.6426 31.9732 29.6426C30.5917 29.6426 29.4717 30.7626 29.4717 32.1441C29.4717 33.5257 30.5917 34.6457 31.9732 34.6457Z",
    fill: "#473D8D"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent2);
export default __webpack_public_path__ + "static/media/component-2.c8bda411b55c7519467774f4b9cc5f52.svg";
export { ForwardRef as ReactComponent };